/* Stores consented, allowlisted content context. Never intercepts checkout or cart quantities. */
(function(root,factory){
  if(typeof module==='object'&&module.exports) module.exports=factory;
  else { var adapter=factory(root); adapter.start(); }
})(typeof window!=='undefined'?window:this,function(w){
  'use strict';
  var C=w.ABArtAttributionCore, KEY='ab_social_v1', ATTR='__ab_social_v1', PROP='properties[_ab_social_v1]';
  var state=null, sent='', lastWrite=null, queue=Promise.resolve();
  var writeNumber=0, activeWrite=null;
  var entry=C.parseEntry(w.location.href), selection=C.parseSelection(w.location.href), applied=false;
  function read(){try{return JSON.parse(w.localStorage.getItem(KEY));}catch(_){return null;}}
  function allowed(){try{var p=w.Shopify.customerPrivacy;return p.analyticsProcessingAllowed()===true&&p.marketingAllowed()===true;}catch(_){return false;}}
  function publish(name,data){try{var a=w.Shopify.analytics;if(a&&typeof a.publish==='function')a.publish(name,data);}catch(_){}}
  function forms(){
    w.document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
      var input=form.querySelector('input[name="'+PROP+'"]');
      if(!state){if(input)input.remove();return;}
      if(!input){input=w.document.createElement('input');input.type='hidden';input.name=PROP;form.appendChild(input);}
      input.value=JSON.stringify(state);
    });
  }
  function cartUrl(suffix){return (w.Shopify.routes&&w.Shopify.routes.root||'/')+'cart'+(suffix?'/'+suffix:'')+'.js';}
  async function write(value){
    if(value===lastWrite&&!activeWrite)return;
    var number=++writeNumber;
    if(activeWrite&&activeWrite.controller)activeWrite.controller.abort();
    var controller=w.AbortController?new w.AbortController():null;
    activeWrite={number:number,controller:controller};
    var attrs={};attrs[ATTR]=value;
    try {var response=await w.fetch(cartUrl('update'),{
      method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',
      signal:controller&&controller.signal,body:JSON.stringify({attributes:attrs})});
      if(!response.ok)throw Error('cart metadata unavailable');
      if(number===writeNumber)lastWrite=value;
    }catch(_){}
    finally{if(number===writeNumber)activeWrite=null;}
    // An older request can finish after a consent revocation even if abort was requested.
    if(number!==writeNumber&&!allowed())await write('');
  }
  async function scrubLineProperties(){
    try{
      var response=await w.fetch(cartUrl(''),{credentials:'same-origin'});
      if(!response.ok)return;
      var cart=await response.json();
      for(var item of cart.items||[]){
        var properties=item.properties||{};
        if(!item.key||!Object.prototype.hasOwnProperty.call(properties,'_ab_social_v1')||!properties._ab_social_v1)continue;
        var cleaned=Object.assign({},properties);cleaned._ab_social_v1='';
        // Shopify change.js replaces all properties. Copy every other property and do not send quantity.
        await w.fetch(cartUrl('change'),{method:'POST',headers:{'Content-Type':'application/json'},
          credentials:'same-origin',body:JSON.stringify({id:item.key,properties:cleaned})});
      }
    }catch(_){}
  }
  async function clearCart(){
    await Promise.all([write(''),scrubLineProperties()]);
  }
  async function update(){
    var previous=read(), consent=allowed();
    state=C.reduce(previous,applied?{}:{direct:entry,selection:selection},Date.now(),consent);
    if(!consent){
      try{w.localStorage.removeItem(KEY);}catch(_){}
      state=null;sent='';applied=false;forms();
      // Private cart attributes are unreadable via cart.js, so clear our owned key even on a new page.
      await clearCart();
      return;
    }
    applied=true;
    if(state){try{w.localStorage.setItem(KEY,JSON.stringify(state));}catch(_){} }
    else{try{w.localStorage.removeItem(KEY);}catch(_){}}
    forms();
    if(!allowed()){state=null;try{w.localStorage.removeItem(KEY);}catch(_){}forms();await clearCart();return;}
    var signature=JSON.stringify(state);
    if(state&&sent!==signature){
      if(allowed()){publish('ab_social_context',{state:state});sent=signature;}
      // One landing per content/placement per 30 min in this browser tab. Reloads do not inflate visits.
      var e=selection||entry;
      if(e){var id='ab_social_visit_'+(e.qa?'qa_':'')+e.placement+'_'+e.creative, now=Date.now(), prior=0;
        try{prior=Number(w.sessionStorage.getItem(id));}catch(_){}
        if(!prior||now-prior>1800000){
          if(allowed())publish(selection?'ab_social_content_select':'ab_social_landing',{state:state,page_location:C.sanitizeUrl(w.location.href)});
          try{w.sessionStorage.setItem(id,String(now));}catch(_){}
        }
      }
    }
    // Cart metadata is best effort. A slow cart endpoint must not suppress the landing event.
    if(allowed()&&(state||previous))void write(state?JSON.stringify(state):'');
  }
  function refresh(){queue=queue.then(update,update);return queue;}
  function start(){
    w.document.addEventListener('visitorConsentCollected',refresh);
    w.addEventListener('pageshow',refresh);
    // Another tab may revoke consent or replace the campaign context.
    w.addEventListener('storage',function(e){if(e.key===KEY)refresh();});
    if(w.MutationObserver)new w.MutationObserver(forms).observe(w.document.documentElement,{childList:true,subtree:true});
    if(w.Shopify&&w.Shopify.customerPrivacy)refresh();
    else if(w.Shopify&&w.Shopify.loadFeatures)w.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(){refresh();});
  }
  return {start:start,refresh:refresh,state:function(){return state;}};
});
